<!--
 * @Description: 面包屑
 * @Author: mileS
 * @Date: 2020-06-10 16:39
 * @LastEditTime: 2020-06-10 16:39
 * @LastEditors: 2020-06-10 16:39
 -->
<template>
  <div class="bread-container">
    <el-breadcrumb separato="/">
      <el-breadcrumb-item class="el-icon-arrow-left">
        <span @click="back">返回</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>媒体报道</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  props: {
    path: {
      type: String,
      default: '/'
    }
  },
  methods: {
    back () {
      this.$router.push(this.path)
    }
  }
}
</script>
<style scoped lang="scss">
  .bread-container{
    width: 1106px;
    margin: 0 auto;
    padding: 30px 0 10px 0;
    cursor: pointer;
    ::v-deep .el-breadcrumb__item[aria-current='page'] .el-breadcrumb__inner{
      font-weight:500;
    }
    ::v-deep .el-breadcrumb__inner{
      color: #282828;
    }
  }
</style>
